// extracted by mini-css-extract-plugin
export default {"scrollbar-shift":"adjustForScrollbar_scrollbar-shift__w4NsR"};